import React, { createContext, useContext, useEffect, useState } from 'react';
import { api } from './api';

const AuthCtx = createContext(null);

const SESSION_FLAG = 'ukgm.session'; // presence hints there might be a valid session

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, obj=user
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      // Skip /auth/me for anonymous visitors — avoids a cosmetic 401 log in DevTools
      // on every public page. The flag is set on login and cleared on logout.
      if (typeof window !== 'undefined' && !localStorage.getItem(SESSION_FLAG)) {
        setUser(false);
        setLoading(false);
        return;
      }
      try {
        const res = await api.get('/auth/me', { validateStatus: (s) => s < 500 });
        if (res.status === 200) {
          setUser(res.data);
        } else {
          try { localStorage.removeItem(SESSION_FLAG); } catch {}
          setUser(false);
        }
      } catch {
        setUser(false);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    try { localStorage.setItem(SESSION_FLAG, '1'); } catch {}
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post('/auth/logout'); } catch {}
    try { localStorage.removeItem(SESSION_FLAG); } catch {}
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
